import { Form, Input, Popover } from "antd"
import { formItemLayoutBalanced } from "../../_components/SettingFormItems"
import * as React from "react"
import { SettingFormItem } from "../../types"
import { WrappedFormUtils } from "antd/lib/form/Form"
import { SketchPicker } from "react-color"
import { useState } from "react"
import { isHexColorValid } from "../../../../../utils/color"

type Props = {
    settings: SettingFormItem
    form: WrappedFormUtils
    onChangeCallback: () => void
}

export const DEFAULT_MIB_COLOR = "50E3C2"

export const MibColorRow = (props: Props) => {
    const [isPickerVisible, setIsPickerVisible] = useState(false)

    const defaultValue = props.settings.MIB_PRIMARY_COLOR.value || DEFAULT_MIB_COLOR
    const options = {
        initialValue: defaultValue,
    }
    return (
        <div>
            <Form.Item
                className="receipt-setting-form-item"
                style={{
                    marginBottom: "0rem",
                }}
                {...formItemLayoutBalanced}
                label="Custom Primary Color">
                {props.form.getFieldDecorator(
                    "MIB_PRIMARY_COLOR",
                    options
                )(
                    <Input
                        className="color-picker-input"
                        style={{
                            width: "12rem",
                            textAlign: "left",
                        }}
                        prefix="#"
                        suffix={
                            <div
                                onClick={() => setIsPickerVisible(true)}
                                style={{
                                    height: "1.87rem",
                                    width: "1.9rem",
                                    border: `1px solid #${props.form.getFieldValue("MIB_PRIMARY_COLOR")}`,
                                    borderLeft: "1px solid #E1E6EB",
                                    borderTopRightRadius: "3px",
                                    borderBottomRightRadius: "3px",
                                    backgroundColor: `#${props.form.getFieldValue("MIB_PRIMARY_COLOR")}`,
                                }}
                            />
                        }
                        onBlur={e => {
                            const valid = isHexColorValid(e.target.value)
                            if (!valid) {
                                props.form.setFieldsValue({
                                    MIB_PRIMARY_COLOR: null,
                                })
                            }

                            if (e.target.value.includes("#")) {
                                props.form.setFieldsValue({
                                    MIB_PRIMARY_COLOR: e.target.value.replace("#", ""),
                                })
                            }
                        }}
                        onChange={() => {
                            props.onChangeCallback()
                        }}
                        placeholder={
                            props.settings.MIB_PRIMARY_COLOR.indeterminate ? "Multiple values" : "Default Color"
                        }
                        onFocus={e => {
                            e.target.select()
                            setIsPickerVisible(true)
                        }}
                    />
                )}
                <Popover
                    content={
                        <div>
                            <SketchPicker
                                disableAlpha={true}
                                color={props.form.getFieldValue("MIB_PRIMARY_COLOR") || defaultValue}
                                onChangeComplete={color => {
                                    props.onChangeCallback()
                                    return props.form.setFieldsValue({
                                        MIB_PRIMARY_COLOR: color && color.hex ? color.hex.substring(1) : null,
                                    })
                                }}
                            />
                        </div>
                    }
                    trigger="click"
                    visible={isPickerVisible}
                    placement="bottom"
                    onVisibleChange={setIsPickerVisible}
                />
            </Form.Item>
        </div>
    )
}
